// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 22V2H2V22H22ZM5.48242 8.17383L17.0732 5.06836L18.1084 8.93164L14.2451 9.9668L16.5742 18.6602L12.7109 19.6963L10.3818 11.0029L6.51758 12.0381L5.48242 8.17383Z"}}]};

const LogoTapdFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'logo-tapd-filled',
    ref,
    icon: element,
  },
));

LogoTapdFilledIcon.displayName = 'LogoTapdFilledIcon';

export default LogoTapdFilledIcon;
